import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Text,
  useTheme,
  Circle,
  Button,
  Flex,
  useDisclosure,
} from '@chakra-ui/react';

import Image from '@repo/ui-components/tailwind/Image';
import NewsletterModal from '@repo/ui-components/dept/molecules/Newsletter/NewsletterModal';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

export default function MiscNews({ newsletter, sidebar, ...props }) {
  const theme = useTheme();
  const { isOpen = true, onOpen, onClose } = useDisclosure();
  const openModal = e => {
    e.preventDefault();
    e.stopPropagation();
    onOpen(e);
  };
  const { tt } = useUiComponentsInternationalContext();

  return (
    <>
      <Flex
        borderRadius="1.5rem"
        backgroundImage={theme.images.greyBackground}
        backgroundSize="cover"
        backgroundPosition="center"
        flexDirection="column"
        justifyContent="space-between"
        p={sidebar ? 6 : 8}
        {...props}
      >
        <Circle w="64px" h="64px" bg="brand.sunny">
          <Image
            alt="PetSafe isotype"
            src={theme.images.isotypeV2}
            width="50%"
          />
        </Circle>
        <Box>
          <Text textStyle="h3" as="h3" fontWeight="black" mb={3}>
            {newsletter.newsletterTitle}
          </Text>
          <Text>{tt(s => s.miscNewsComponent.subscribeDescriptionLabel)}</Text>
          <Button
            w="100%"
            variant="secondary"
            mt={sidebar ? 8 : 16}
            mb={6}
            onClick={openModal}
          >
            {tt(s => s.miscNewsComponent.subscribeButton)}
          </Button>
          <Text textStyle="caption" fontWeight="bold" color="typography.light">
            {newsletter.newsletterDescription}
          </Text>
        </Box>
      </Flex>
      <NewsletterModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}

MiscNews.defaultProps = {
  sidebar: false,
};

MiscNews.propTypes = {
  sidebar: PropTypes.bool,
  newsletter: PropTypes.shape({
    newsletterTitle: PropTypes.string,
    newsletterDescription: PropTypes.string,
  }).isRequired,
};
